import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _Set from "@babel/runtime-corejs3/core-js/set";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { flatten } from "lodash";
import TimelineCard from "./utils/timeline-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineDripCampaign",
  components: {
    TimelineCard
  },
  props: {
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    sentAt: {
      type: [String, null],
      default: null
    },
    details: {
      type: Object,
      required: true
    },
    stageId: {
      type: String,
      required: true
    },
    scheduledDate: {
      type: String,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    },
    campaignName: {
      type: String,
      required: true
    },
    sent: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      required: true
    },
    deleted: {
      type: Boolean,
      required: true
    },
    subscribed: {
      type: Boolean,
      required: true
    },
    addition: {
      type: Boolean
    },
    items: {
      type: Array,
      required: true
    },
    timelineList: {
      type: Array,
      required: true
    }
  },
  computed: {
    campaignClass() {
      return this.active ? "text-secondary" : "text-danger";
    },
    campaignTitle() {
      return this.active ? this.$t("client-profile.messages.activeCampaign") : this.$t("client-profile.messages.inactiveCampaign");
    },
    stageNumber() {
      var _context, _context2, _context3, _context4, _context5;
      const listItems = _mapInstanceProperty(_context = this.timelineList).call(_context, ({
        items
      }) => items);
      const stages = _sortInstanceProperty(_context2 = _mapInstanceProperty(_context3 = _filterInstanceProperty(_context4 = flatten(listItems)).call(_context4, ({
        campaignId
      }) => campaignId === this.campaignId)).call(_context3, ({
        stageId
      }) => stageId)).call(_context2, (a, b) => _parseInt(a) - _parseInt(b));
      return _indexOfInstanceProperty(_context5 = [...new _Set(stages)]).call(_context5, this.stageId) + 1;
    },
    dripCampaignDetailsPath() {
      return {
        name: "drip-campaign-edit",
        params: {
          campaignId: this.campaignId
        }
      };
    }
  }
});